import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './AlertModalBoca.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class AlertModalBoca extends Component {
    render() {
	  	return (
			<div>
		  		<Modal isOpen={this.props.isModalOpenBoca} toggle={this.toggle}>
		          	<ModalHeader toggle={this.props.toggleAlertModalBoca}>{this.props.modalTitle}</ModalHeader>
		          	<ModalBody>
						{this.props.modalDescription}
					</ModalBody>
		          	<ModalFooter className="justify-content-center">
		            	<button 
		            		className="showtix-button showtix-background__grey-1"
                            onClick={this.props.toggleAlertModalBoca}
		            		>{strings.no}</button>
                        <button 
		            		className="showtix-button showtix-background__primary-3"
                            onClick={this.props.confirmAlertModalBoca}
                            disabled={this.props.disabled}
		            		>{strings.yes}</button>    
		          	</ModalFooter>
		        </Modal>
			</div>
	  	);
	}
}

AlertModalBoca.propTypes = {
    modalTitle: PropTypes.string,
    modalDescription: PropTypes.element,
    isModalOpenBoca: PropTypes.bool,
    toggleAlertModalBoca: PropTypes.func,
    confirmAlertModalBoca: PropTypes.func,
}

export default AlertModalBoca;


// WEBPACK FOOTER //
// ./src/components/Common/AlertModalBoca/AlertModalBoca.js